/**
 * Autofocus Controller
 *
 * Automatically focuses an input field when it is connected to the DOM.
 * This is a technical helper for improving UX on search fields and forms.
 *
 * Usage:
 *   <%= form.text_field :query, data: { controller: 'autofocus' } %>
 *
 * Note: This controller extends ApplicationController for consistency and error handling,
 * but does NOT track breadcrumbs. Autofocus is a technical event (automatic on page load),
 * not a user action. Per observability patterns, we only track user-initiated actions.
 *
 * @extends ApplicationController
 */
import ApplicationController from './application_controller'

export default class extends ApplicationController {
  connect() {
    // Focus the input element automatically
    // No breadcrumb tracking: This is a technical event, not a user action
    this.element.focus()
  }
}
